import { HttpClient } from "@angular/common/http";
import { Injectable, inject, DestroyRef, signal, computed } from "@angular/core";
import { tap } from "rxjs";
import { SelectOption, SelectOptionWithSelected } from "../../shared/interfaces/select-option";
import { LoadingService } from "../../shared/services/loading.service";

@Injectable({
    providedIn: 'root',
})
export class TransactionTypeService {
    private api: string = `investments/poolInvestments/transactiontype/`;
    #httpClient = inject(HttpClient);
    #loadingService = inject(LoadingService);

    private _transactionTypes = signal<SelectOption[]>([]);

    readonly transactionTypes = this._transactionTypes.asReadonly();
    readonly transactionTypesWithSelect = computed(() => {
        return this._transactionTypes().map((option) => {
            return {
                ...option,
                selected: false
            } as SelectOptionWithSelected;
        });
    });

    getTransactionTypes() {
        this.#loadingService.showLoadingIndicator();
        return this.#httpClient.get<SelectOption[]>(`${this.api}transaction-types`).pipe(
            tap(response => {
                this._transactionTypes.set(response);
                this.#loadingService.hideLoadingIndicator();
            })
        );
    }
}
